import React, { PureComponent } from "react";
import NavigatorMain from "../NavigatorMain";
import { hashHistory } from "react-router";
import { connect } from "react-redux";
import "./ServiceReport.css";
import { getServiceReportDetail, serviceReporDetailDel } from "../../action/ServiceReportAction";
import Util from "../../util";

class ServiceReportDetail extends PureComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const typeDetail = ["notice", "weekly", "quarterly"];
    const titleType = {
      notice: "公告详情",
      weekly: "周报详情",
      quarterly: "季报详情",
    };
    document.title = titleType[typeDetail[this.props.location.state.detailType]];
  
    const { dispatch } = this.props;
    const param = { id: this.props.location.state.id };
    param.id !== "null" && dispatch(getServiceReportDetail(param));
    param.id === "null" && dispatch(serviceReporDetailDel());
  }
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(serviceReporDetailDel());
  }
  goBack = () => {
    hashHistory.goBack();
  };
  typeComponents = {
    notice: () => {
      const { serviceReporDetail } = this.props;
      return (
        <div className="SR_con_wrap" style={{ maxHeight: document.documentElement.clientHeight /*  window.screen.height */ }}>
          <NavigatorMain>
            <div className="SR_header" style={{ height: "1.82rem" }}>
              <div className="SR_header_con" style={{ paddingBottom: ".22rem" }}>
                <div className="SR_goback_btn" onClick={this.goBack}>
                  <img src={require("../../img/n_icon_goback.png")} />
                </div>
                <div className="SR_header_tit">公告详情</div>
              </div>
            </div>
          </NavigatorMain>
          <div style={{ flex: "auto", overflowY: "scroll" }}>
            <div className="SR_detail_tit">{serviceReporDetail.title}</div>
            <div className="SR_detail_date">华夏财富 {serviceReporDetail.newsTime && serviceReporDetail.newsTime.slice(5)}</div>
            <div className="SR_detail_con">{serviceReporDetail.detail}</div>
          </div>
        </div>
      );
    },
    weekly: () => {
      const imgUrl = `${Util.imgUrl}${this.props.serviceReporDetail.detail}`;
      return (
        <div className="SR_con_wrap" style={{ maxHeight: document.documentElement.clientHeight /*  window.screen.height */ }}>
          <NavigatorMain>
            <div className="SR_header" style={{ height: "1.82rem" }}>
              <div className="SR_header_con" style={{ paddingBottom: ".22rem" }}>
                <div className="SR_goback_btn" onClick={this.goBack}>
                  <img src={require("../../img/n_icon_goback.png")} />
                </div>
                <div className="SR_header_tit">周报详情</div>
              </div>
            </div>
          </NavigatorMain>
          <img src={imgUrl} style={{ width: "100%" }} />
        </div>
      );
    },
    quarterly: () => {
      // return <div style={{ textAlign: "center", paddingTop: "2rem" }}>季报</div>;
      return (
        <div className="SR_con_wrap" style={{ maxHeight: document.documentElement.clientHeight /*  window.screen.height */ }}>
          <NavigatorMain>
            <div className="SR_header" style={{ height: "1.82rem" }}>
              <div className="SR_header_con" style={{ paddingBottom: ".22rem" }}>
                <div className="SR_goback_btn" onClick={this.goBack}>
                  <img src={require("../../img/n_icon_goback.png")} />
                </div>
                <div className="SR_header_tit">季报详情</div>
              </div>
            </div>
          </NavigatorMain>
          <div>季报</div>
        </div>
      );
    },
  };

  render() {
    const typeDetail = ["notice", "weekly", "quarterly"];
    const { serviceReporDetail } = this.props;
    document.title =  serviceReporDetail && serviceReporDetail.type == 0 ? '公告详情' : serviceReporDetail && serviceReporDetail.type == 1 ? '周报详情' : serviceReporDetail && serviceReporDetail.type == 1 ? '季报详情' : '投顾服务报告'
    return (
      <div className="container" style={{ maxHeight: document.documentElement.clientHeight, background: "#fff" }}>
        {serviceReporDetail && this.typeComponents[typeDetail[serviceReporDetail.type] || "quarterly"]()}
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    serviceReporDetail: state.serviceReportReducer.serviceReporDetail,
  };
}
export default connect(mapStateToProps)(ServiceReportDetail);



// WEBPACK FOOTER //
// ./src/components/fundDetail/ServiceReportDetail.js